<template>
<div>

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" />

    <!-- WAITING -->
    <div v-if="state == 'waiting'">
        <h1 class="title">{{ texts.teleEvaluation }}</h1>
        <p>{{ texts.teleEvaluationMsg }}</p>
        <p class="header-local-name">
            {{ user }}
        </p>
        <br>
        <b-carousel
            :interval=5000
            :has-drag=false
            :arrow=false
            :indicator=false
            :pause-hover=false
        >
            <b-carousel-item v-for="(advice, i) in config.advices" :key="i">
                <div class="advice">
                    <img class="advice-image" :src="`/static/advices/${advice}`" />
                </div>
            </b-carousel-item>
        </b-carousel>
        <div
            class="actions actions-center"
        >
            <a
                class="button is-warning is-fullwidth btn-action"
                @click="disconnect()"
            >
                {{ texts.disconnect }}
            </a>
        </div>
    </div>

    <!-- CALLING -->
    <div v-if="state == 'calling'">
        <p class="header-remote-name">{{ remoteUser }}</p>
        <h1 class="title calling">{{ texts.calling }}</h1>
        <button
            class="button calling-btn is-success"
            @click="accept()"
        >
            <b-icon
                pack="fas"
                icon="video"
                custom-class="calling-icon"
            />
        </button>
        <p @click="accept()" class="accept-call-msg">{{ texts.acceptCallMessage }}</p>
        <div class="actions actions-center actions-bottom">
            <button
                class="button is-danger actions-btn"
                @click="hangup(false)"
            >
                <b-icon
                    pack="fas"
                    icon="times">
                </b-icon>
            </button>
        </div>
    </div>

    <!-- INCALL -->
    <div v-if="state == 'incall'" class="actions">
        <p class="header-remote-name">{{ remoteUser }}</p>
        <button style="visibility:hidden" class="button actions-btn" />
        <button
            v-show="!isChatOpened"
            class="button is-danger actions-btn"
            @click="hangup(true)"
        >
            <b-icon
                pack="fas"
                icon="times">
            </b-icon>
        </button>
        <button v-if="!config.userSettings" style="visibility:hidden" class="button actions-btn" />
        <div
            v-if="config.userSettings"
            v-show="!isChatOpened"
            class="actions-btn fab"
            :class="{
                'fab-hover': isFabHover
            }"
            @click="isFabHover = !isFabHover"
        >
            <span
                class="fab-action-button videortc-icon-Settings"
            >
            </span>
            <ul
                class="fab-buttons fab-buttons-reset-left"
            >
                <li
                    v-if="config.userSettings.chat"
                    class="fab-buttons-item"
                >
                    <a
                        class="fab-buttons-link fab-blue"
                        @click="openChat()"
                    >
                        <b-icon
                            pack="fas"
                            icon="comment-alt">
                        </b-icon>
                    </a>
                </li>
                <li
                    v-if="config.userSettings.toggleAudio"
                    class="fab-buttons-item"
                >
                    <a
                        class="fab-buttons-link"
                        @click="toggleAudio()"
                    >
                        <b-icon
                            pack="fas"
                            :icon="!isAudioMuted ? 'microphone' : 'microphone-slash'"
                        >
                        </b-icon>
                    </a>
                </li>
                <li
                    v-if="config.userSettings.toggleVideo"
                    class="fab-buttons-item"
                >
                    <a
                        class="fab-buttons-link"
                        @click="toggleVideo()"
                    >
                        <b-icon
                            pack="fas"
                            :icon="!isVideoMuted ? 'video' : 'video-slash'"
                        >
                        </b-icon>
                    </a>
                </li>
                <li
                    v-if="config.userSettings.replaceVideo"
                    class="fab-buttons-item"
                >
                    <a
                        class="fab-buttons-link"
                        @click="replaceVideo()"
                    >
                        <b-icon
                            pack="fas"
                            icon="sync-alt"
                        >
                        </b-icon>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="slow-link" v-if="slowLink">{{ texts.slowLink }}</div>
    <div v-show="state == 'incall'" id="videocall"></div>
    <div v-show="state == 'incall' && isChatOpened" class="chat">
        <div
            class="chat-panel"
            @click="hideChat()"
        ></div>
        <div class="chat-actions">
            <b-field class="chat-input">
                <p class="control">
                    <b-button
                        class="button is-danger"
                        size="is-medium"
                        @click="hideChat(true)"
                    >
                        <b-icon
                            pack="fas"
                            icon="times-circle"
                        />
                    </b-button>
                </p>
                <b-input
                    ref="chatMsg"
                    v-model="chatMsg"
                    v-on:keyup.native.enter="sendMsg()"
                    :placeholder="texts.typeMessage"
                    type="text"
                    size="is-medium"
                    expanded
                />
                <p class="control">
                    <b-button
                        class="button is-info"
                        size="is-medium"
                        @click="sendMsg()"
                    >
                        <b-icon
                            pack="fas"
                            icon="arrow-alt-circle-right"
                        />
                    </b-button>
                </p>
            </b-field>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';

export default {
    name: 'CallUser',
    mixins: [ Utils ],
    data () {
        return {
            isFabHover: false,
            config: {},
            texts: {},
            role: 'u',
            state: 'waiting', // 'waiting' || 'calling' || 'incall'
            session: null,
            sessionData: {},
            user: null,
            professionalAlias: null,
            userGw: null,
            remoteUser: null,
            remoteUserGw: null,
            patternProffesional: null,
            patternUser: null,
            videortc: {
                app: null,
                ucases: null,
                actions: null,
            },
            callingTone: null,
            isLoading: true,
            chatMsg: '',
            isChatOpened: false,
            isAudioMuted: false,
            isVideoMuted: false,
            waitingDialog: null,
            remoteHasVideo: null,
            slowLink: null,
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
        this.user = localStorage.getItem('username');
        this.session = localStorage.getItem('session');
        this.patternProffesional = /^([a-zA-Z0-9]+)\|(p)\|([^\|]+)$/;
        this.patternUser = /^([a-zA-Z0-9]+)\|(u)\|([^\|]+)\|(\d+)\|(\d+)\|([^\|]+)$/;
        HealthCareService.getSession(this.session)
            .then(res => {
                this.sessionData = res.data;
                this.userGw = `${this.config.prefix}|${this.role}|${this.user}|${moment(this.sessionData.start).unix()}|${moment(this.sessionData.end).unix()}|${this.sessionData.professional}`;
                this.connect();
            })
            .catch(error => {
                const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                setTimeout(() => {
                    this.$router.push('/');
                }, 1000);
            })
    },
    methods: {
        toggleAudio() {
            this.isAudioMuted = this.videortc.actions.toggleAudio();
        },
        toggleVideo() {
            this.isVideoMuted = this.videortc.actions.toggleVideo();
        },
        replaceVideo() {
            if (!this.config.replaceVideo) return;
            this.setLoading(true);
            this.videortc.actions.replaceVideo('next');
            setTimeout(() => {
                this.setLoading(false);
            }, 500);
        },
        setLoading(isLoading) {
            this.isLoading = isLoading;
        },
        connect() {
            this.videortc.app = new VideoRTC(server, iceServers, debugLevel, apiSecret);
            this.videortc.app.connect()
                .then(usecases => {
                    this.ucases = usecases;
                    this.startVideocall();
                })
                .catch(cause => {
                    this.setLoading(false);
                    this.$buefy.toast.open({ message: cause || 'Error connecting with the VideoRTC', type: 'is-danger', position: 'is-bottom' });
                });
        },
        startVideocall() {
            const onEvents = {
                onAccepted: () => {
                    this.vueInsomnia().off();
                    if (this.callingTone) this.stopSound(this.callingTone);
                    this.state = 'incall';
                    setTimeout(() => {
                        this.videortc.actions.setCall(true, true, this.config.quality);
                    }, 5000);
                },
                onCalling: () => {},
                onGotPeers: list => {},
                onHangUp: (user, reason) => {
                    this.slowLink = null;
                    if (this.callingTone) this.stopSound(this.callingTone);
                    this.state = 'waiting';
                },
                onIncomingCall: user => {
                    if (this.sessionData.autoConnect) this.waitingDialog.close();
                    if (window.navigator.vibrate) window.navigator.vibrate(200);
                    this.remoteUserGw = user;
                    const matches = this.remoteUserGw.match(this.patternProffesional) || this.remoteUserGw.match(this.patternUser);
                    this.remoteUser = `${matches[3]}`;
                    if (this.remoteUser === this.sessionData.professional && this.sessionData.professionalAlias) this.remoteUser = this.sessionData.professionalAlias;
                    this.state = 'calling';
                    this.callingTone = this.playSound('ringtone.wav', true);
                },
                onRegistered: (user, isRegistered) => {
                    this.vueInsomnia().on();
                    if (!isRegistered) {
                        this.$buefy.toast.open({ message: this.texts.connectingError, type: 'is-danger', position: 'is-bottom' });
                        this.disconnect();
                    }
                    else if (this.sessionData.autoConnect) {
                        this.waitingDialog = this.$buefy.dialog.alert({
                            message: this.texts.waitingProfessionalMsg,
                            confirmText: this.texts.accept,
                            type: 'is-info'
                        })
                    }
                },
                onSetCall: () => {

                },
                onDataReceived: (type, data, filename) => {
                    if(type === 'application/x-chat') {
                        this.$buefy.notification.open({
                            message: data,
                            type: 'is-success',
                            closable: false,
                            position: 'is-top-right',
                            duration: 30000,
                            queue: false
                        })
                    }
                },
                onRemoteStreamReady: (isReady, stream) => {
                    if (isReady) this.remoteHasVideo = true;
                    if (this.remoteHasVideo) {
                        this.slowLink = !isReady;
                    }
                },
            };
            const domElements = {
                videos: document.getElementById('videocall'),
            };
            const options = {
                stream: {
                    resolution: this.config.resolution,
                },
                dataChannel: {
                    dataEnabled: this.config.chat,
                },
                display: {
                    namePattern: null,
                },
            };
            if (this.config.account) options.account = this.config.account;
            this.ucases.videoCall(onEvents, domElements, options)
                .then(acts => {
                    this.videortc.actions = acts;
                    this.register();
                    this.setLoading(false);
                })
                .catch(cause => {
                    this.setLoading(false);
                    this.$buefy.toast.open({ message: cause || 'Error', type: 'is-danger', position: 'is-bottom' });
                });
        },
        disconnect() {
            this.videortc.app.disconnect();
            this.$router.push(`/join/${this.session}/accept`);
        },
        register() {
            this.videortc.actions.register(this.userGw);
        },
        accept() {
            this.videortc.actions.acceptCall();
        },
        hangup(confirmation) {
            if (!confirmation) {
                this.videortc.actions.hangUp();
                this.state = 'waiting';
                return;
            }
            this.$buefy.dialog.confirm({
                message: this.texts.endCall,
                cancelText: this.texts.no,
                confirmText: this.texts.yes,
                type: 'is-success',
                onConfirm: () => {
                    this.videortc.actions.hangUp();
                    this.disconnect();
                },
            });
        },
        openChat() {
            this.isChatOpened = true;
            this.$refs.chatMsg.focus();
        },
        hideChat(conf) {
            if (conf || this.chatMsg === '') {
                this.isChatOpened = false;
                this.chatMsg = '';
            }
        },
        sendMsg() {
            this.videortc.actions.sendData(
                'application/x-chat',
                this.chatMsg,
                ok => {
                    this.chatMsg = '';
                    this.hideChat();
                },
                ko => {});
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.videortc-icon-Settings {
    font-size: 58px;
    padding-top: 2px !important;
    padding-left: 1px;
}
.fab {
    cursor: pointer;
}
.fab-hover .fab-buttons {
    opacity: 1;
    visibility: visible;
}
.fab-hover .fab-buttons-link {
    transform: scaleY(1) scaleX(1) translateY(-16px) translateX(0px);
}
/*.fab-action-button:hover + .fab-buttons .fab-buttons-link:before {
    visibility: visible;
    opacity: 1;
    transform: scale(1);
    transform-origin: right center 0;
    transition-delay: 0.3s;
}*/
.fab-action-button {
    padding-top: 18px;
    position: absolute;
    bottom: 0;
    display: block;
    width: 60px;
    height: 60px;
    background-color: rgb(212, 212, 212);
    color: #363636;
    border-radius: 50%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}
.fab-buttons {
    position: absolute;
    left: 0px;
    right: 0px;
    bottom: 45px;
    width: 100px;
    list-style: none;
    margin: 0;
    padding: 0;
    opacity: 0;
    visibility: hidden;
    transition: 0.2s;
}
.fab-buttons-reset-left {
    left: initial;
}
.fab-buttons-item {
    display: block;
    text-align: center;
    margin: 12px 0;
}
.fab-buttons-link {
    padding-top: 11px;
    color: #363636;
    display: inline-block;
    width: 48px;
    height: 48px;
    text-decoration: none;
    background-color: #ffffff;
    border-radius: 50%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
    transform: scaleY(0.5) scaleX(0.5) translateY(0px) translateX(0px);
    -moz-transition: .3s;
    -webkit-transition: .3s;
    -o-transition: .3s;
    transition: .3s;
}
.fab-red {
    background: #ff3860;
    color: #fff;
}
.fab-blue {
    background: #167df0 !important;
    color: #fff;
}
.header-remote-name {
    position: fixed;
    z-index: 2;
    top: 15px;
    left: 50%;
    transform: translate(-50%);
    background: rgba(250,250,250,0.5);
    padding: 3px 5px;
    border-radius: 3px;
}
.accept-call-msg {
    margin-top: 45px;
    cursor: pointer;
}
.calling {
    margin-top: 20vh;
    @media (max-height: 450px) {
        margin-top: 10px;
        margin-bottom: 0px;
    }
}
.calling-btn {
    top: 22px;
    z-index: 3;
    height: 140px;
    width: 140px;
    border-radius: 70px;
    font-size: 2.2em;
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) infinite;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
    @media (max-height: 450px) {
        height: 100px;
        width: 100px;
        top: 55px;
    }
}
@keyframes shake {
    10%, 90% {
        transform: translate3d(-1px, 0, 0);
    }
    20%, 80% {
        transform: translate3d(2px, 0, 0);
    }
    30%, 50%, 70% {
        transform: translate3d(-4px, 0, 0);
    }
    40%, 60% {
        transform: translate3d(4px, 0, 0);
    }
}
.header-local-name {
    display: inline-block;
    font-size: 1em;
    background:rgba(230,230,230,0.5);
    padding: 3px 5px;
    border-radius: 5px;
}
.actions {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    z-index: 2;
    .actions-btn {
        border-radius: 30px;
        height: 60px;
        width: 60px;
    }
}
.actions-center {
    justify-content: center;
    z-index: 2;
}
.actions-bottom {
    position: absolute;
    margin-bottom: 0;
}
.btn-action {
    height: 60px;
    font-size: 1.3em;
    bottom: 20px;
    width: auto;
    top: 0px;
    width: 100%;
    max-width: 500px;
}
.advice {
    margin: 20px;
    .advice-image {
        max-height: 35vh;
    }
}

.chat {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 400px;
    max-width: 100%;
    height: 100vh;
    z-index: 2;
    .chat-panel {
        height: calc(100% - 45px);
        width: 100%;
        position: fixed;
        left: 0;
    }
    .chat-actions {
        height: 45px;
        width: 100%;
        bottom: 0;
        position: absolute;
    }
}
.tag {
    height: auto;
    padding: 0px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/Call.vue